import axios from 'axios'
import { API_PATH } from '../constants'
import { SetupInterceptors } from './SetupInterceptors'

export const http = axios.create({
    baseURL: API_PATH
})

SetupInterceptors(http, false)

export const httpImage = axios.create({
    baseURL: API_PATH
})

SetupInterceptors(httpImage, true)
